"use-client";

import { endOfWeek, startOfWeek, compareDesc, subDays, getHours, getDay } from "date-fns";
import { DateRange } from "react-day-picker";
import { Calendar, type CalendarProps } from "./calendar";
import { BEIJING_NOW_DATE } from "@/00-shared/const";
import { useDisabledDate } from "@/03-presenters/shared/hooks";
export const getFirstMonday = (date: Date) => startOfWeek(date, {
  weekStartsOn: 1
});
export const getLastSaturday = (date: Date) => endOfWeek(date, {
  weekStartsOn: 1
});

/** Select the whole week when the day is clicked. */
export default function WeekPicker(props: CalendarProps & {
  onSelect: (data: Date) => void;
  isDashboard?: boolean;
}) {
  const {
    selected,
    onSelect,
    isDashboard,
    ...rest
  } = props;
  const disabledDate = useDisabledDate(isDashboard);
  const weekTo = getLastSaturday(selected as Date);
  const today = new Date();
  const maxWeekTo = compareDesc(weekTo, today) === 1 ? weekTo : today;
  const formatWeek: DateRange = {
    from: getFirstMonday(selected as Date),
    to: maxWeekTo
  };
  const disbaledDay = (() => {
    // 周一下午前三点，禁用前一周
    if (getDay(getFirstMonday(BEIJING_NOW_DATE)) === getDay(BEIJING_NOW_DATE) && getHours(BEIJING_NOW_DATE) < 15) {
      return subDays(getFirstMonday(BEIJING_NOW_DATE), 8);
    }
    return subDays(getFirstMonday(BEIJING_NOW_DATE), 1);
  })();
  return <Calendar modifiers={{
    selected: formatWeek
  }} onDayClick={day => {
    onSelect(getFirstMonday(day));
  }} classNames={{
    button: "rounded-none"
  }} disabled={{
    before: disabledDate,
    after: disbaledDay
  }} {...rest} data-sentry-element="Calendar" data-sentry-component="WeekPicker" data-sentry-source-file="week-picker.tsx" />;
}